import Modifier from 'ember-modifier';
import { action } from '@ember/object';

export default class registerOptionElement extends Modifier {
  @action
  modify(element, positional, { callback, selected }) {
    callback(element, selected);
  }
}
